import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../utils/cn";

const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap rounded-lg text-sm font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60",
  {
    variants: {
      variant: {
        primary:
          "bg-gradient-to-r from-brand-400 to-brand-600 text-brand-25 shadow-md shadow-brand-900/15 hover:from-brand-500 hover:to-brand-700 focus-visible:ring-brand-500",
        secondary:
          "bg-white text-brand-700 border border-brand-100 shadow-sm hover:bg-brand-25/70 focus-visible:ring-brand-500",
        default:
          "bg-white text-brand-700 border border-brand-100 shadow-sm hover:bg-brand-25/70 focus-visible:ring-brand-500",
        ghost:
          "text-brand-600 hover:bg-brand-50/70 focus-visible:ring-brand-500",
        danger:
          "bg-danger-500 text-white shadow-sm shadow-danger-900/15 hover:bg-danger-600 focus-visible:ring-danger-400",
        outline:
          "border border-brand-200 bg-transparent text-brand-700 hover:bg-brand-50 focus-visible:ring-brand-500"
      },
      size: {
        xs: "h-8 px-2.5 text-xs",
        sm: "h-9 px-3",
        md: "h-10 px-4",
        lg: "h-12 px-6 text-base",
        icon: "h-9 w-9 p-0"
      },
      fullWidth: {
        true: "w-full",
        false: ""
      }
    },
    defaultVariants: {
      variant: "primary",
      size: "md",
      fullWidth: false
    }
  }
);

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, fullWidth, ...props }, ref) => (
    <button
      ref={ref}
      className={cn(buttonVariants({ variant, size, fullWidth }), className)}
      {...props}
    />
  )
);

Button.displayName = "Button";

export const buttonStyles = buttonVariants;
